export function initAccordion() {
  const accordionWrappers = document.querySelectorAll(".js-accordion_wrapper");
  const activeAccordionClass = "m-active_accordion";

  if (accordionWrappers.length) {
    accordionWrappers.forEach((accordionWrapper) => {
      if (accordionWrapper.__initialized) return;

      accordionWrapper.__initialized = true;

      const accordionHeaders = accordionWrapper.querySelectorAll(
        ".js-accordion_header"
      );
      const accordionContents = accordionWrapper.querySelectorAll(
        ".js-accordion_content"
      );

      accordionHeaders.forEach((header) => {
        header.addEventListener("click", function (event) {
          let el = event.target;
          while (el && el !== this) {
            if (el.tabIndex >= 0 || el.tagName === 'LABEL') return;
            el = el.parentElement;
          }
          const content = this.nextElementSibling;
          const isActive = content.style.maxHeight;

          accordionHeaders.forEach((headerItem) => {
            if (header !== headerItem) {
              headerItem.classList.remove(activeAccordionClass);
            }
          });

          header.classList.toggle(activeAccordionClass, !isActive);

          accordionContents.forEach((item) => {
            item.style.maxHeight = null;
          });

          if (!isActive) {
            const contentChildren = Array.from(content.children);
            let maxHeight = 0;

            // calculation max-height of content to prevent wrong behavior on iOS
            contentChildren.forEach((contentChild) => {
              const styles = getComputedStyle(contentChild);

              maxHeight += contentChild.offsetHeight + parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
            });

            requestAnimationFrame(() => {
              content.style.maxHeight = content.scrollHeight + "px";
            });
          }
        });
      });
    });
  }
}
